import React from "react";

export default function FooterBar() {
  return (
    <footer className="erp-footer-wrap">
      <div className="erp-footer-card">
        <div>
          <div className="erp-footer-title">Modern ERP Workspace</div>
          <div className="erp-footer-subtitle">
            Unified production, lots, inventory, approval sales, reporting and AI.
          </div>
        </div>
        <div className="erp-footer-tags">
          <span className="erp-footer-tag">Live sync</span>
          <span className="erp-footer-tag">Light UI</span>
          <span className="erp-footer-tag">Animated</span>
        </div>
      </div>
    </footer>
  );
}
